import { z } from 'zod';

/**
 * Validation schema for broadcast email generation form
 */
export const generateBroadcastSchema = z.object({
    prompt: z
        .string()
        .trim()
        .min(1, 'Please describe what you want your email to be about')
        .max(2000, 'Prompt is too long. Please keep it under 2000 characters'),
});

export type GenerateBroadcastFormData = z.infer<typeof generateBroadcastSchema>;
